module.exports = __webpack_public_path__ + "img/two.8083e4c5.png";